let channelTaxonomy: import("./api/distribution").PublishingTaxonomy | undefined;
export function setPublishingTaxonomy(taxonomy: import("./api/distribution").PublishingTaxonomy) {
	channelTaxonomy = taxonomy;
}
export function publishingTerms(group: keyof import("./api/distribution").PublishingTaxonomy) {
	return channelTaxonomy?.[group] ?? [];
}
export function publishingTerm(
	group: keyof import("./api/distribution").PublishingTaxonomy,
	id: string,
	locale: string,
) {
	return publishingTerms(group).find((term) => term.id === id)?.label[locale.startsWith("zh") ? 1 : 0] ?? id;
}
